import React from 'react';
import { VBox } from '../../../../components/Box';
import { FormField } from '../../../../components/FormFields';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';

import styles from './CreditInvoiceEmailModal.module.css'
import ButtonComponent from './../../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';

const CreditInvoiceEmailModal = ({
  invoice,
  sendToTargetEmail,
  manualEmail,
  updateInvoiceEmailData,
  addApiError,
  finalizeV2,
  setSendToTargetEmail,
  setManualEmail,
  lbl,
  resetCreditInvoiceEmailModal,
  manualEmailValue,
  skipEmail,
}) => {
  const targetEmail = invoice.emailTo || invoice.emailContact?.email_address || invoice.financialContact?.email_address;
  const sendToTargetEmailValue = sendToTargetEmail;

  const saveDisable = () => {
    if (!sendToTargetEmailValue) {
      return true;
    }
    if (sendToTargetEmailValue === 'manual' && !manualEmail) {
      return true;
    }
    return false;
  };

  const onCheckBoxChange = value => {
    setSendToTargetEmail(value);
  };

  const onSave = () => {
    if (sendToTargetEmailValue === 'no') {
      skipEmail();
      return;
    }

    const emailTo = sendToTargetEmailValue === 'manual' ? manualEmail : targetEmail;

    updateInvoiceEmailData({ emailTo }, response => {
      if (response.validationErrors) {
        let errorMsg = 'general';
        if (response.validationErrors) {
          errorMsg = Object.values(response.validationErrors[0]?.constraints ?? {})[0] ?? '';
        }
        addApiError(errorMsg);
      } else {
        finalizeV2();
        resetCreditInvoiceEmailModal();
      }
    });
  };

  return (
    <ModalComponent onClose={resetCreditInvoiceEmailModal}>
      <VBox left>
        <span>Do you want to email the credit invoice to this email address:</span>
        <strong>{targetEmail}</strong>
        <VBox
          style={{
            width: `100%`,

            margin: '0',
            backgroundColor: '#F5F6FA',
            boxShadow: 'inset 0 0 0 5px white',
            padding: '15px',
          }}
          vCenter
        >
          <div className="option-container">
            <CheckboxComponent
              label={lbl('yes')}
              checked={sendToTargetEmailValue === 'yes'}
              onChange={() => {
                onCheckBoxChange('yes');
              }}
            >

            </CheckboxComponent>
          </div>
          <div className="option-container">
            <CheckboxComponent
              label={lbl('no')}
              checked={sendToTargetEmailValue === 'no'}
              onChange={() => {
                onCheckBoxChange('no');
              }}
            >

            </CheckboxComponent>
          </div>
          <div className="option-container">
            <CheckboxComponent
              label={lbl('notification.email_modal.manual_email')}
              checked={sendToTargetEmailValue === 'manual'}
              onChange={() => {
                onCheckBoxChange('manual');
              }}
            >

            </CheckboxComponent>
          </div>
          {sendToTargetEmailValue === 'manual' && (
            <FormField>
              <input className='form-control' name="manualEmail" value={manualEmailValue} onChange={evt => setManualEmail(evt.target.value)} />
            </FormField>
          )}
        </VBox>
      </VBox>

        <div className={styles.buttonFooter}>
              <ButtonComponent
                style={'ButtonSoftDelete'}
                onClick={resetCreditInvoiceEmailModal}
              >
                {lbl(`cancel`)}
              </ButtonComponent>

              <ButtonComponent style="ButtonSoftPrimary" disabled={saveDisable()} onClick={onSave}>
                 {lbl('save')}
              </ButtonComponent>
            </div>
    </ModalComponent>
  );
};

export default CreditInvoiceEmailModal;
